module.exports = __webpack_public_path__ + "cross.png?6022c2d6215c90d97afd341a478905d4";